import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Group } from "src/app/shared/models/group.model";
import Swal from "sweetalert2";
import { AdminService } from "../../admin/admin-service";
import { StorageService } from "../../services/storage.service";
import { StorageKey } from "../../storage.model";

@Component({
  selector: "app-submit-application",
  templateUrl: "./submit-application.component.html",
  styleUrls: ["./submit-application.component.scss"],
})
export class SubmitApplicationComponent implements OnInit {
  formGroup: FormGroup;
  status_list: any;
  description: any;
  @Input() group: Group;
  info: string;
  user: any;
  user_data: any;
  principal: any;
  position: any;
  constructor(
    private service: AdminService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private storeSvc: StorageService
  ) {
    this.info = localStorage.getItem("userInfo");
    if (this.info) {
      this.user = this.storeSvc.read(StorageKey.CURRENT_USER);
      this.user_data = this.user.data;
      if (this.user_data) {
        this.principal = this.user_data.principal;
        this.position = this.principal.position.name;
      }
    }
  }

  ngOnInit(): void {
    this.status();
    this.formGroup = this.initFormGroup();
  }

  initFormGroup(): FormGroup {
    return this.formBuilder.group({
      comment: ["", Validators.required],
    });
  }

  save(param) {
    const payload = {
      comment: param.comment,
      statusId: 3,
      groupProfileId: this.group.id,
      closed: this.group.closed,
    };

    if (payload) {
      this.saveProfile(payload);
    }
  }

  reject(param) {
    const payload = {
      comment: param.comment,
      statusId: 5,
      groupProfileId: this.group.id,
      closed: this.group.closed,
    };

    if (payload) {
      this.saveProfile(payload);
    }
  }

  decline(param) {
    const payload = {
      comment: param.comment,
      statusId: 6,
      groupProfileId: this.group.id,
      closed: this.group.closed,
    };

    if (payload) {
      this.saveProfile(payload);
    }
  }

  status() {
    this.service.status().subscribe((response) => {
      this.status_list = response.data;
    });
  }

  saveProfile(param) {
    this.service.submitApplication(param).subscribe((response) => {
      this.description = response.description;
      if (this.description) {
        this.description = this.description;
      } else {
        this.description = "Process Failed";
      }
      if (response.code === 200) {
        // Swal.fire(response.description, "", "success");
      } else {
        // Swal.fire(response.description, "", "error");
      }
    });
  }
}
